import './styles.scss';
export { FavouriteButton } from './FavouriteButton';
export { FavouriteNoResult } from './FavouriteNoResult';



// WEBPACK FOOTER //
// ./src/components/Favourite/index.js